var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-ueditor-wrap',{key:_vm.skey,attrs:{"editor-id":_vm.id,"config":_vm.config},on:{"input":_vm.input},model:{value:(_vm.values),callback:function ($$v) {_vm.values=$$v},expression:"values"}})
}
var staticRenderFns = []

export { render, staticRenderFns }